{
  "WALLBOARD": {
    "LOADING": "Telefon kuyrukları yükleniyor...",
    "NO_QUEUES": "Telefon kuyruğu bulunamadı.",
    "NO_AGENTS": "Bu kuyrukta çevrimiçi temsilci yok.",
    "UNKNOWN_CALLER": "Bilinmeyen Arayan",
    "STATUS": "Durum",
    "TIME": "Zaman",
    "AGENT": "Temsilci",
    "EXTENSION": "Dahili",
    "READY": "Hazır Temsilciler",
    "ON_CALL": "Görüşmedeki Temsilciler",
    "PAUSED": "Molada Olan Temsilciler",
    "WAITING": "Bekleyen çağrılar",
    "MISSED_CALLS": "Cevapsız çağrılar",
    "HANDLED_CALLS": "Karşılanan gelen çağrılar",
    "OUTBOUND_CALLS": "Gerçekleştirilen giden çağrılar",
    "AVAILABILITY": "Müsaitlik",
    "AVAILABILITY_TOOLTIP": "Temsilciler tarafından yanıtlanan gelen çağrıların yüzdesi (cevaplanan çağrılar)",
    "AGENTS_COUNT": "({onCall} görüşmede / {total} toplam)",
    "NO_AVAILABLE": "(çevrimiçi kimse yok)",
    "WAITING_CALLERS_COUNT": "{count} bekliyor",
    "CALLER": "Arayan",
    "NUMBER": "Numara",
    "WAIT_TIME": "Bekleme Süresi",
    "ACTION": "Eylem",
    "PICKUP_CALL": "Yanıtla",
    "PICKUP_SUCCESS": "Çağrıyı alma isteği başarıyla gönderildi.",
    "PICKUP_ERROR": "Çağrı alınamadı. Lütfen tekrar deneyin.",
    "PICKUP_DISABLED_TOOLTIP": "Görüşme halindeyken veya çevrimdışıyken çağrı alamazsınız.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Erişim yok"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Erişim yok"
    }
  }
}
